import { render, staticRenderFns } from "./subject-form-3.vue?vue&type=template&id=2c54489c&scoped=true&"
import script from "./subject-form-3.vue?vue&type=script&lang=ts&"
export * from "./subject-form-3.vue?vue&type=script&lang=ts&"
import style0 from "./subject-form-3.vue?vue&type=style&index=0&id=2c54489c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c54489c",
  null
  
)

export default component.exports